import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface InventoryFeature {
  title: string;
  tag: string;
  image: string;
  points: string[];
}

@Component({
  selector: 'app-inventory-features',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './inventory-features.html',
  styleUrls: ['./inventory-features.css'],
})
export class InventoryFeaturesComponent {
  readonly features: InventoryFeature[] = [
    {
      title: 'Items & Products',
      tag: 'Items',
      image: 'images/modules/item.PNG',
      points: ['Item catalog & SKUs', 'Reorder levels', 'Batch tracking', 'Stock by warehouse'],
    },
    {
      title: 'Price Tags & Barcodes',
      tag: 'Price Tags',
      image: 'images/modules/price.PNG',
      points: ['Barcode label designer', 'Custom tag templates', 'Multiple paper sizes', 'Print or save as PDF'],
    },
    {
      title: 'Units of Measure',
      tag: 'Units',
      image: 'images/modules/unit.PNG',
      points: ['Custom units — pcs, dozen, carton, box', 'Unit ordering & codes', 'Active/inactive status'],
    },
    {
      title: 'Warehouses',
      tag: 'Warehouses',
      image: 'images/modules/warehouse.PNG',
      points: ['Multiple warehouse types', 'Retail store support', 'Location tracking', 'Stock per location'],
    },
  ];
}
